import { saveAs } from 'file-saver';
import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as Close } from '../../assets/icons/close.svg';
import Page from '../../pages/Page';
import { tag } from '../../services/ATInternetService';
import PrimaryButton from '../buttons/primarybutton/PrimaryButton';
import PrimaryIconButton from '../buttons/primaryiconbutton/PrimaryIconButton';
import H2 from '../text/H2';
import './CardPhoto.sass';

const CardPhoto = ({ shareData, onDone }) => {
	return <Page className="z-50 bg-primary-900 cardphoto flex flex-col content-center justify-center items-center">

		<PrimaryIconButton className="cardphoto__closebutton absolute right-6 top-6" onClick={onDone}><Close /></PrimaryIconButton>

		<img src={window.photo} alt="Klokhuis Scanner foto" className="mb-4 shadow-2xl" />


		{!/iPad|iPhone|iPod/.test(navigator.platform) ? <PrimaryButton
			onClick={() => {
				const shareImage = async () => {
					if (navigator.canShare && navigator.canShare(shareData)) {
						navigator.share(shareData);
					} else {
						saveAs(window.photo, `Klokhuis Scanner foto ${String(Math.floor(Date.now() / 1000))}.png`);
					}

					tag.sendClick('photo', {
						name: 'photo-shared-android',
					});
				}
				shareImage();
			}}
			className="mb-4">
			Delen
		</PrimaryButton> : <H2 className="cardphoto__info mb-12 text-white text-center">Houd je foto ingedrukt om &apos;m te delen of op te slaan!</H2>}
	</Page>;
}

CardPhoto.propTypes = {
	onDone: PropTypes.func.isRequired
}

export default CardPhoto;
